"use client";
import type { CashierCurrencyType } from "@workspace/casino_core/schema";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import { useEffect } from "react";
import useCashier from "@/client/components/CashierWrap/useCashier";
import MicroFrontend from "@/client/components/MicroFrontend";
import { preloadCashierAssets } from "@/client/components/MicroFrontend/cashierAssets";

type Props = {
  isMobile: boolean;
  site: Site;
  type: CashierCurrencyType;
  name: CashierCurrency;
  currentTheme?: ColorScheme;
  cashierUrl: string;
  isProtoEnabled: boolean;
};

const CashierWrap: FC<Props> = ({
  isMobile,
  site,
  type,
  name,
  currentTheme,
  cashierUrl,
  isProtoEnabled,
}) => {
  const { isOpen, elementRef, handleClose } = useCashier({
    site,
    isMobile,
    type,
    name,
    currentTheme,
    isProtoEnabled,
  });

  useEffect(() => {
    const preload = () => preloadCashierAssets(cashierUrl);
    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(preload, { timeout: 5000 });
      return () => window.cancelIdleCallback(id);
    }
    const id = setTimeout(preload, 2000);
    return () => clearTimeout(id);
  }, [cashierUrl]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-10000 bg-black/70 fs-mask">
      <main
        className={classNames(
          "fixed z-10000 h-full w-full overflow-y-scroll bg-secondary sm:absolute sm:max-w-md",
          !isMobile && "ltr:right-0 rtl:left-0",
          site === "bitcasino" &&
            "[&_.btn-primary]:text-background [&_.btn-tertiary]:text-foreground",
        )}
        ref={elementRef}
      >
        <MicroFrontend
          host={cashierUrl}
          onClose={handleClose}
          currentTheme={currentTheme}
          name="Cashier"
        />
      </main>
    </div>
  );
};
export default CashierWrap;
